export default function Footer() {
  const scrollToSection = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-cream-100 py-16 md:py-20">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="max-w-5xl mx-auto">
          {/* Top Section */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8 mb-12 md:mb-16">
            {/* Brand */}
            <div>
              <h3 className="text-charcoal-300 text-sm font-semibold tracking-[0.15em] uppercase mb-4">
                LET MONEY SERVE
              </h3>
              <p className="text-charcoal-100 text-sm leading-relaxed">
                A movement for intentional financial stewardship. Building peace, visibility, and practice into how we handle money.
              </p>
            </div>

            {/* Navigation */}
            <div>
              <h4 className="text-charcoal-300 text-sm font-medium mb-4">Explore</h4>
              <div className="space-y-3">
                <button
                  onClick={() => scrollToSection('#philosophy')}
                  className="block text-charcoal-100 text-sm hover:text-sage-500 transition-colors"
                >
                  Philosophy
                </button>
                <button
                  onClick={() => scrollToSection('#platform')}
                  className="block text-charcoal-100 text-sm hover:text-sage-500 transition-colors"
                >
                  Platform
                </button>
                <button
                  onClick={() => scrollToSection('#essays')}
                  className="block text-charcoal-100 text-sm hover:text-sage-500 transition-colors"
                >
                  Essays
                </button>
                <button
                  onClick={() => scrollToSection('#testimonials')}
                  className="block text-charcoal-100 text-sm hover:text-sage-500 transition-colors"
                >
                  Stories
                </button>
              </div>
            </div>

            {/* Connect */}
            <div>
              <h4 className="text-charcoal-300 text-sm font-medium mb-4">Connect</h4>
              <div className="space-y-3">
                <button
                  onClick={() => scrollToSection('#cta')}
                  className="block text-charcoal-100 text-sm hover:text-sage-500 transition-colors"
                >
                  Get Early Access
                </button>
                <a
                  href="#"
                  rel="noopener noreferrer"
                  className="block text-charcoal-100 text-sm hover:text-sage-500 transition-colors"
                >
                  Newsletter
                </a>
                <a
                  href="#"
                  rel="noopener noreferrer"
                  className="block text-charcoal-100 text-sm hover:text-sage-500 transition-colors"
                >
                  Contact
                </a>
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t border-sand-200 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-charcoal-50 text-xs">
              &copy; 2026 LET MONEY SERVE. All rights reserved.
            </p>
            <p className="font-serif text-charcoal-50 text-xs italic">
              Make money serve what matters.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}